// export const updateValue = (state, payload) => {
//     state.value = payload
//   }

let mutations = {};
mutations.fn_countDanhGia = (state) => {
  state.danhGia.refreshFnCountNew--;
};

export default mutations;
